import { HashInfo } from "../../types";
import HashListItem from "./HashListItem";
import { HashListContainer } from "./HashList.styled";
import { Helper } from "../../helper/helper";


const HashList = ({ hashInfoList }: { hashInfoList?: HashInfo[] }) =>
  hashInfoList?.length ? (
    <HashListContainer>
      {hashInfoList
        .sort((a, b) => Helper.getBuildNumber(b.version) - Helper.getBuildNumber(a.version))
        .map((data: HashInfo, index: number) => HashListItem({ index, data }))}
    </HashListContainer>
  ) : null;

export default HashList;
